import { render, staticRenderFns } from "./indexV2.vue?vue&type=template&id=7a2e7c04&scoped=true&"
import script from "./indexV2.vue?vue&type=script&lang=js&"
export * from "./indexV2.vue?vue&type=script&lang=js&"
import style0 from "./indexV2.vue?vue&type=style&index=0&id=7a2e7c04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2e7c04",
  null
  
)

export default component.exports